import { render, staticRenderFns } from "./RoadmapBaseEventsModal.vue?vue&type=template&id=23a728de&"
import script from "./RoadmapBaseEventsModal.vue?vue&type=script&lang=js&"
export * from "./RoadmapBaseEventsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports